export default {
    methods: {
        numberWithCommas (number) {
            if (number) {
                number = number.toFixed(2).toString()
                const pattern = /(-?\d+)(\d{3})/
                while (pattern.test(number)) { number = number.replace(pattern, '$1,$2') }
                return number
            }
        }
    }
}
